import { ReactNode } from 'react';
import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../lib/cn';

interface Props {
  title?: string;
  back?: boolean;
  right?: ReactNode;
  className?: string;
}

export function TopBar({ title, back, right, className }: Props) {
  const navigate = useNavigate();
  return (
    <header className={cn(
      'sticky top-0 z-30 h-14 bg-bg/85 backdrop-blur border-b border-border flex items-center px-3',
      className,
    )}>
      <div className="w-10 flex justify-start">
        {back && (
          <button
            onClick={() => navigate(-1)}
            className="p-1.5 -ml-1.5 text-fg-muted hover:text-fg rounded-md"
            aria-label="Back"
          >
            <ChevronLeft size={22} />
          </button>
        )}
      </div>
      <div className="flex-1 text-center text-base font-bold tracking-wide">{title}</div>
      <div className="w-10 flex justify-end">{right}</div>
    </header>
  );
}
